import logo from './logo.svg';
import './App.css';
import Rendering from "./Calendar"
import moment from 'moment'
import Login from "./login"
import {
  momentLocalizer,
} from 'react-big-calendar'
import { useState } from 'react';
import { Grid, Box } from '@mui/material';
function App() {
  const mLocalizer = momentLocalizer(moment)
  let [user, setUser] = useState(null);
  return (
    <div className="App">
      <Grid container>
        {[
          "4/1/2026",
          "5/1/2026",
          "6/1/2026",
          "7/1/2026",
          "8/1/2026",
          "9/1/2026",
          "10/1/2026",
          "11/1/2026",
          "12/1/2026",
          "1/1/2027",
          "2/1/2027",
          "3/1/2027",
          "4/1/2027",
          "5/1/2027",
          "6/1/2027",
          "7/1/2027",
        ].map(date => {
          return <Grid item >
            <Box sx={
              {
                width: {
                  xl: "31vw",
                  lg: "49vw",
                  md: "49vw",
                  sm: "100vw",
                  xs: "100vw"
                },

                height: {
                  xl: "calc( 31vw * 0.8)",
                  lg: "calc( 49vw * 0.8)",
                  md: "calc( 41vw * 0.8)",
                  sm: "calc( 100vw * 0.8)",
                  xs: "calc( 100vw * 0.8)"
                }
              }
            } margin={'.5vw'}>

              <Rendering localizer={mLocalizer} setupDate={date}></Rendering>
            </Box>
          </Grid>
        })}
      </Grid>

    </div >
  );
}

export default App;
